import React from "react";
import { useBrandLogo } from "./hooks/useBrandLogo";
import PhotoWidgetV2 from "ui/widgets/photoUploader/PhotoWidgetV2";

export const BrandLogo = () => {
  const { logoUrl, handleUploadLogo } = useBrandLogo();

  return (
    <div className="tw-flex tw-flex-col tw-justify-start tw-items-start">
      <div className="tw-relative tw-w-[250px] tw-h-[72px]">
        <PhotoWidgetV2
          selected={logoUrl}
          width={250}
          height={62}
          onChange={handleUploadLogo}
          aspect={250 / 60}
          showButton={false}
          placeHolderClickable
          showRemoveButton
        />
      </div>
      <div className="tw-text-xs tw-text-[#818E9E] tw-leading-tight">
        Recommended format:
        <br />
        250 × 60 pixels (PNG or JPG)
      </div>
    </div>
  );
};
